import type { CookieConsentConfig } from 'vanilla-cookieconsent';
import * as CookieConsent from 'vanilla-cookieconsent';
import { analytics } from '@/services/analytics';

export const cookieConsentConfig: CookieConsentConfig = {
  guiOptions: {
    consentModal: {
      layout: 'box wide',
      position: 'bottom center',
    },
    preferencesModal: {
      layout: 'box',
    },
  },

  categories: {
    necessary: {
      enabled: true,
      readOnly: true,
    },
    functionality: {},
    analytics: {
      autoClear: {
        cookies: [
          { name: /^mp_/ }, // Mixpanel cookies
        ],
      },
    },
    marketing: {},
  },

  onConsent: ({ cookie }) => {
    if (cookie.categories.includes('analytics')) {
      analytics.init();
    }
  },

  onChange: ({ changedCategories }) => {
    if (changedCategories.includes('analytics')) {
      const hasAnalytics = CookieConsent.acceptedCategory('analytics');
      if (hasAnalytics) {
        analytics.init();
      } else {
        analytics.disable();
      }
    }
  },

  language: {
    default: 'de',
    translations: {
      de: {
        consentModal: {
          title: 'Wir verwenden Cookies',
          description:
            'Diese Website verwendet Cookies und ähnliche Technologien, um Ihnen den bestmöglichen Service zu bieten. Mit Klick auf "Alle akzeptieren" stimmen Sie der Verwendung aller Cookies zu. Sie können Ihre Einstellungen jederzeit anpassen.',
          acceptAllBtn: 'Alle akzeptieren',
          acceptNecessaryBtn: 'Nur notwendige',
          showPreferencesBtn: 'Einstellungen',
        },
        preferencesModal: {
          title: 'Cookie-Einstellungen',
          acceptAllBtn: 'Alle akzeptieren',
          acceptNecessaryBtn: 'Nur notwendige',
          savePreferencesBtn: 'Einstellungen speichern',
          closeIconLabel: 'Schließen',
          sections: [
            {
              title: 'Cookie-Nutzung',
              description:
                'Wir verwenden Cookies, um grundlegende Funktionen zu ermöglichen und Ihre Nutzungserfahrung zu verbessern. Sie können für jede Kategorie wählen, ob Sie zustimmen möchten oder nicht.',
            },
            {
              title: 'Notwendige Cookies',
              description:
                'Diese Cookies sind für die Grundfunktionen der Website erforderlich. Sie ermöglichen grundlegende Funktionen wie die Benutzeranmeldung und Seitennavigation.',
              linkedCategory: 'necessary',
            },
            {
              title: 'Funktionale Cookies',
              description:
                'Funktionale Cookies ermöglichen erweiterte Funktionen und Personalisierung. Sie speichern Ihre Präferenzen wie die Sidebar-Einstellung.',
              linkedCategory: 'functionality',
            },
            {
              title: 'Analyse Cookies',
              description:
                'Diese Cookies helfen uns zu verstehen, wie Besucher mit der Website interagieren. Wir verwenden Mixpanel zur Nutzungsanalyse.',
              linkedCategory: 'analytics',
            },
            {
              title: 'Marketing Cookies',
              description:
                'Marketing-Cookies werden verwendet, um Besuchern relevante Werbung anzuzeigen. Derzeit setzen wir keine Marketing-Cookies ein.',
              linkedCategory: 'marketing',
            },
            {
              title: 'Weitere Informationen',
              description:
                'Bei Fragen zu unserer Cookie-Richtlinie kontaktieren Sie uns bitte oder lesen Sie unsere <a href="/datenschutz" target="_blank">Datenschutzerklärung</a>.',
            },
          ],
        },
      },
    },
  },
};
